var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 20.4999C19.8325 20.4999 23.75 16.5824 23.75 11.7499C23.75 6.91745 19.8325 2.99994 15 2.99994C10.1675 2.99994 6.25 6.91745 6.25 11.7499C6.25 16.5824 10.1675 20.4999 15 20.4999ZM15 7.99994C14.6449 7.99994 14.4074 8.42599 13.9324 9.27808L13.8095 9.49853C13.6746 9.74066 13.6071 9.86173 13.5019 9.94162C13.3966 10.0215 13.2656 10.0512 13.0035 10.1105L12.7648 10.1644C11.8424 10.3731 11.3813 10.4775 11.2715 10.8303C11.1618 11.1832 11.4762 11.5508 12.105 12.2862L12.2677 12.4764C12.4464 12.6854 12.5358 12.7898 12.5759 12.9191C12.6161 13.0483 12.6026 13.1877 12.5756 13.4665L12.551 13.7203C12.456 14.7014 12.4084 15.192 12.6957 15.41C12.9829 15.6281 13.4148 15.4293 14.2784 15.0316L14.5018 14.9288C14.7472 14.8158 14.8699 14.7593 15 14.7593C15.1301 14.7593 15.2528 14.8158 15.4982 14.9288L15.7216 15.0316C16.5852 15.4293 17.0171 15.6281 17.3043 15.41C17.5916 15.192 17.544 14.7014 17.449 13.7203L17.4244 13.4665C17.3974 13.1877 17.3839 13.0483 17.4241 12.9191C17.4642 12.7898 17.5536 12.6854 17.7323 12.4764L17.895 12.2862C18.5238 11.5508 18.8382 11.1832 18.7285 10.8303C18.6187 10.4775 18.1576 10.3731 17.2352 10.1644L16.9965 10.1105C16.7344 10.0512 16.6034 10.0215 16.4981 9.94162C16.3929 9.86173 16.3254 9.74066 16.1904 9.49853L16.0676 9.27808C15.5926 8.42599 15.3551 7.99994 15 7.99994Z",
    fill: "url(#paint0_linear_3583_85147)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86626 20.4268L8.3928 22.1538C7.60737 25.0186 7.21466 26.451 7.73872 27.2352C7.92238 27.51 8.16875 27.7306 8.45465 27.8761C9.27043 28.2915 10.53 27.6352 13.0491 26.3225C13.8873 25.8858 14.3065 25.6674 14.7518 25.62C14.9168 25.6024 15.0832 25.6024 15.2482 25.62C15.6935 25.6674 16.1126 25.8858 16.9508 26.3225C19.47 27.6352 20.7296 28.2915 21.5454 27.8761C21.8312 27.7306 22.0776 27.51 22.2613 27.2352C22.7853 26.451 22.3926 25.0186 21.6072 22.1538L21.1337 20.4268C19.4011 21.6539 17.2847 22.3751 15 22.3751C12.7153 22.3751 10.5989 21.6539 8.86626 20.4268Z",
    fill: "url(#paint1_linear_3583_85147)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3583_85147",
    x1: 16.1349,
    y1: 2.99994,
    x2: 16.1349,
    y2: 20.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3583_85147",
    x1: 15.9728,
    y1: 20.4268,
    x2: 15.9728,
    y2: 28.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.d97b15b7b20d6ae151c717ffb98d1024.svg";
export { ForwardRef as ReactComponent };